module.exports = __webpack_public_path__ + "img/frame_1.59a939e.png";